import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/auth-slice';
import dashboardReducer from '@/features/dashboard/dashboard-slice';
import tenantReducer from '@/features/tenants/tenant-slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    tenant: tenantReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
